import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { isAuthenticated } from '../lib/auth.js'
import { redirectToOAuthSignIn } from '../utils/oauth.js'
import { useAuthConfig } from '../config/appConfig.jsx'

// Predicate-checks `auth?.email && auth?.accessToken` (via isAuthenticated)
// and, when missing, kicks the OAuth /oauth2/authorize flow with the current
// path as returnTo. Mirrors Workbench's AuthGuard pattern (ops auth doc §4
// AC#2). The PR #95 lesson: token-only checks let unauthenticated users land
// on protected routes silently — keep this predicate the single source of
// truth for "is this user signed in?".
export default function AuthGuard({ children }) {
  const location = useLocation()
  const authConfig = useAuthConfig()
  const [redirecting, setRedirecting] = useState(false)
  const authed = isAuthenticated()

  useEffect(() => {
    if (authed || redirecting) return
    setRedirecting(true)
    redirectToOAuthSignIn(authConfig, {
      returnTo: location.pathname + location.search,
    }).catch((err) => {
      console.error('[AuthGuard] OAuth redirect failed:', err)
      setRedirecting(false)
    })
  }, [authed, redirecting, authConfig, location])

  if (!authed) return null
  return children
}
